// extracted by mini-css-extract-plugin
export default {"container":"with-button_container__hV3o+","loader":"with-button_loader__82YbE"};